(() => {
  const SEP = '::';
  const MAX_FILE_BYTES = 15 * 1024 * 1024;
  const MAX_PROP_LEN = 600;
  const MAX_RECEITAS_PADRAO = 3;

  function formatBytes(bytes) {
    if (!bytes && bytes !== 0) {
      return '';
    }
    if (bytes === 0) {
      return '0 B';
    }
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
    const n = bytes / Math.pow(k, i);
    const rounded = i === 0 ? Math.round(n) : n.toFixed(1);
    return `${rounded} ${sizes[i]}`;
  }

  function linhaReceitaSatisfeitaNoCart(item) {
    if (!item || !item.properties) {
      return false;
    }
    const p = item.properties;
    const ok = String(p['_receita_ok'] ?? p._receita_ok ?? '')
      .trim()
      .toLowerCase();
    if (ok === '1' || ok === 'true') {
      return true;
    }
    const nome = String(p['_receita_nome'] ?? p._receita_nome ?? '').trim();
    return nome.length > 0;
  }

  async function syncCheckoutBlocking() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      return;
    }
    const btn = drawer.querySelector('#CartDrawer-Checkout');
    if (!btn) {
      return;
    }

    const isLink = btn.tagName === 'A';
    const setBlocked = (blocked) => {
      if (isLink) {
        if (blocked) {
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('tabindex', '-1');
        } else {
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute('tabindex');
        }
      } else {
        btn.disabled = blocked;
        if (blocked) {
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.removeAttribute('aria-disabled');
        }
      }
      btn.classList.toggle('ec-cart-footer__checkout-button--blocked', blocked);
    };

    const uploads = drawer.querySelectorAll('[data-ec-receita-upload]');
    if (uploads.length === 0) {
      setBlocked(false);
      return;
    }

    try {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      let bloquear = false;
      uploads.forEach((el) => {
        const line = parseInt(el.dataset.line, 10);
        const lineItem = cart.items && cart.items[line - 1];
        if (!linhaReceitaSatisfeitaNoCart(lineItem)) {
          bloquear = true;
        }
      });
      setBlocked(bloquear);
    } catch (e) {
      const incomplete = drawer.querySelector('[data-ec-receita-upload][data-receita-complete="false"]');
      setBlocked(!!incomplete);
    }
  }

  function ecApplyCartDrawerSectionHtml(sectionHtml) {
    if (!sectionHtml || typeof sectionHtml !== 'string') {
      return Promise.resolve();
    }
    if (window.ecShippingCalculatorState && typeof window.ecShippingCalculatorState.save === 'function') {
      window.ecShippingCalculatorState.save();
    }
    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const srcDrawer = parsed.querySelector('cart-drawer');
    const liveDrawer = document.querySelector('cart-drawer');
    if (liveDrawer && srcDrawer) {
      liveDrawer.classList.toggle('is-empty', srcDrawer.classList.contains('is-empty'));
    }
    ['cart-drawer-items', '.drawer__footer'].forEach((selector) => {
      const targetElement = document.querySelector(selector);
      const sourceElement = parsed.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
    });
    if (typeof window.ecResetCartDrawerShippingClientState === 'function') {
      window.ecResetCartDrawerShippingClientState({ skipDom: true });
    }
    if (window.ecShippingCalculatorState && typeof window.ecShippingCalculatorState.restore === 'function') {
      window.ecShippingCalculatorState.restore();
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ec-receita' });
    }
    return syncCheckoutBlocking();
  }

  function ecReceitaRefreshDrawerFromSection() {
    const cartUrl = window.routes?.cart_url || '/cart';
    return fetch(`${cartUrl}?section_id=cart-drawer`)
      .then((r) => r.text())
      .then((responseText) => ecApplyCartDrawerSectionHtml(responseText))
      .catch((e) => console.error(e));
  }

  function ecSectionHtmlFromChangeResponse(data) {
    const sec = data && data.sections;
    if (!sec || typeof sec !== 'object') {
      return '';
    }
    return (
      sec['cart-drawer'] ||
      sec.cart_drawer ||
      sec['template--cart-drawer'] ||
      Object.values(sec).find((v) => typeof v === 'string' && v.includes('cart-drawer-items')) ||
      ''
    );
  }

  async function ecReceitaSaveProps(line, quantity, patch) {
    const root = window.Shopify?.routes?.root || '/';
    const cart = await fetch(`${root}cart.js`).then((r) => r.json());
    const item = cart.items[line - 1];
    if (!item) {
      throw new Error('Linha inválida');
    }

    const props = { ...(item.properties || {}) };
    Object.assign(props, patch);

    const changeUrl = window.routes?.cart_change_url || '/cart/change.js';
    const sectionsUrl = typeof window !== 'undefined' && window.location && window.location.pathname ? window.location.pathname : '/';
    const res = await fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line,
        quantity,
        properties: props,
        sections: ['cart-drawer'],
        sections_url: sectionsUrl,
      }),
    });
    const data = await res.json();
    if (data.errors || data.message) {
      const msg = typeof data.message === 'string' ? data.message : JSON.stringify(data.errors || data);
      throw new Error(msg);
    }
    const inlineHtml = ecSectionHtmlFromChangeResponse(data);
    if (inlineHtml) {
      await ecApplyCartDrawerSectionHtml(inlineHtml);
    } else {
      await ecReceitaRefreshDrawerFromSection();
    }
    return data;
  }

  async function onFileSelected(input, file) {
    const wrap = input.closest('[data-ec-receita-upload]');
    if (!wrap || !file) {
      return;
    }

    const line = parseInt(wrap.dataset.line, 10);
    const maxReceitas = parseInt(wrap.dataset.receitaMax, 10) || MAX_RECEITAS_PADRAO;

    if (file.size > MAX_FILE_BYTES) {
      window.alert('Arquivo muito grande. Envie até 15 MB.');
      return;
    }

    const root = window.Shopify?.routes?.root || '/';
    const cart = await fetch(`${root}cart.js`).then((r) => r.json());
    const item = cart.items[line - 1];
    if (!item) {
      return;
    }

    const props = { ...(item.properties || {}) };
    const existingN = (props['_receita_nome'] || '').split(SEP).filter(Boolean);
    const existingS = (props['_receita_tamanho'] || '').split(SEP).filter((_, i) => i < existingN.length);

    if (existingN.length >= maxReceitas) {
      window.alert(
        'Você pode anexar no máximo 3 receitas neste item. Remova uma receita para adicionar outra.'
      );
      input.value = '';
      return;
    }

    existingN.push(file.name);
    existingS.push(formatBytes(file.size));

    const newNome = existingN.join(SEP);
    const newSize = existingS.join(SEP);
    if (newNome.length > MAX_PROP_LEN) {
      window.alert('Os nomes dos arquivos ultrapassam o limite permitido. Use arquivos com nomes mais curtos ou remova um anexo.');
      input.value = '';
      return;
    }

    try {
      await ecReceitaSaveProps(line, item.quantity, {
        _receita_ok: '1',
        _receita_nome: newNome,
        _receita_tamanho: newSize,
      });
    } catch (e) {
      console.error(e);
      window.alert('Não foi possível salvar a receita. Tente novamente.');
    } finally {
      input.value = '';
    }
  }

  async function onRemoveFile(wrap, index) {
    const line = parseInt(wrap.dataset.line, 10);
    const root = window.Shopify?.routes?.root || '/';
    const cart = await fetch(`${root}cart.js`).then((r) => r.json());
    const item = cart.items[line - 1];
    if (!item) {
      return;
    }

    const props = { ...(item.properties || {}) };
    const nomes = (props['_receita_nome'] || '').split(SEP).filter(Boolean);
    const sizes = (props['_receita_tamanho'] || '').split(SEP);

    nomes.splice(index, 1);
    sizes.splice(index, 1);

    let patch;
    if (nomes.length === 0) {
      patch = { _receita_ok: '', _receita_nome: '', _receita_tamanho: '' };
    } else {
      patch = {
        _receita_ok: '1',
        _receita_nome: nomes.join(SEP),
        _receita_tamanho: sizes.slice(0, nomes.length).join(SEP),
      };
    }

    try {
      await ecReceitaSaveProps(line, item.quantity, patch);
    } catch (e) {
      console.error(e);
      window.alert('Não foi possível remover o arquivo.');
    }
  }

  function bindCartDrawerReceita() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.ecReceitaDelegated === 'true') {
      return;
    }
    drawer.dataset.ecReceitaDelegated = 'true';

    drawer.addEventListener('click', (e) => {
      const add = e.target.closest('[data-ec-receita-trigger], [data-ec-receita-add-more]');
      if (add) {
        const wrap = add.closest('[data-ec-receita-upload]');
        const input = wrap?.querySelector('[data-ec-receita-input]');
        if (input) {
          e.preventDefault();
          input.click();
        }
      }

      const remove = e.target.closest('[data-ec-receita-remove]');
      if (remove) {
        e.preventDefault();
        const wrap = remove.closest('[data-ec-receita-upload]');
        const idx = parseInt(remove.getAttribute('data-file-index'), 10);
        if (wrap && !Number.isNaN(idx)) {
          onRemoveFile(wrap, idx);
        }
      }
    });

    drawer.addEventListener('change', (e) => {
      const input = e.target.closest('[data-ec-receita-input]');
      if (!input || !input.files?.length) {
        return;
      }
      const file = input.files[0];
      onFileSelected(input, file);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindCartDrawerReceita();
    void syncCheckoutBlocking();

    document.addEventListener(
      'submit',
      async (e) => {
        const form = e.target;
        if (!form || form.id !== 'CartDrawer-Form') {
          return;
        }
        if (e.submitter && e.submitter.getAttribute('name') !== 'checkout') {
          return;
        }
        await syncCheckoutBlocking();
        const btn = document.querySelector('#CartDrawer-Checkout');
        if (btn && btn.disabled) {
          e.preventDefault();
        }
      },
      true
    );
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      requestAnimationFrame(() => {
        void syncCheckoutBlocking();
        bindCartDrawerReceita();
      });
    });
  }
})();
